module.exports = __webpack_public_path__ + "static/img/logo_white_education.a883b0ab.png";